import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { to: "/", label: "Home", exact: true },
  { to: "/recipes", label: "Recipes" },
  { to: "/resources", label: "Resources" },
  { to: "/about", label: "About" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-md"
      style={{
        backgroundColor: "rgba(253, 251, 247, 0.85)",
        borderBottom: "1px solid var(--jaf-border)",
      }}
    >
      <div className="jaf-container flex h-16 items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.exact}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-[color:var(--jaf-primary)] ${
                  isActive ? "text-[color:var(--jaf-primary)]" : "text-[color:var(--jaf-text)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          data-testid="hamburger-toggle"
          className="md:hidden p-2 rounded-md text-[color:var(--jaf-text)]"
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle navigation"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-nav"
          className="md:hidden border-t"
          style={{ borderColor: "var(--jaf-border)", backgroundColor: "var(--jaf-bg)" }}
        >
          <nav className="jaf-container py-4 flex flex-col gap-2">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.exact}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `block py-2.5 px-2 text-base font-medium rounded-md transition-colors ${
                    isActive
                      ? "text-[color:var(--jaf-primary)] bg-[color:var(--jaf-surface)]"
                      : "text-[color:var(--jaf-text)] hover:bg-[color:var(--jaf-surface)]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
